import OrderConfirmation from './order-confirmation';
import OrderConfirmationView from './order-confirmation.view';

export * from './order-confirmation';
export * from './order-confirmation.data';
export * from './order-confirmation.view';
export * from './order-confirmation.props.autogenerated';
export * from './components';

export {
    OrderConfirmation,
    OrderConfirmationView
};